import TeamItem from "./TeamItem";

const SeasonTeams = ({teams, title}) => {
    return (
        <>
            <div className="card">
                <div className="card-header">
                    <h3 className="card-title">
                        <i className="ion ion-clipboard mr-1"></i>
                        {title}
                    </h3>
                </div>
                <div className="card-body">
                    <ul className="todo-list">
                        {teams?.map((Team) => (
                            Team
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );
}

export default SeasonTeams;